import { render, staticRenderFns } from "./FeatList.vue?vue&type=template&id=11bb2aab&"
import script from "./FeatList.vue?vue&type=script&lang=js&"
export * from "./FeatList.vue?vue&type=script&lang=js&"
import style0 from "./FeatList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports